import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { OrderCustomerModel, PageBase, LocationInfo, VehicleInfo, NoteInfo, T4TurboOrderService, AuthService } from 't4core';
import { CustomerInfo } from '../../components/CustomerInfo/CustomerInfo.component';
import { ContractDialog } from '../../dialogs/ContractDialog/ContractDialog';
import { TerminationDialog } from '../../dialogs/TerminationDialog/TerminationDialog';
import { T4DatatableWidget } from '../../../../t4common';
import moment, { duration } from 'moment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { OrderService } from '../../Services/order.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CancellationToken } from 'typescript';
import { resolve } from '@angular/compiler-cli/src/ngtsc/file_system';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'ActiveContracts',
    templateUrl: './ActiveContracts.html',
    styleUrls: ['./ActiveContracts.css']
})
export class IndatasComponent extends PageBase {

    @ViewChild("customerinfo", {static: false}) table: CustomerInfo;
    @ViewChild("tblActiveContracts", { static: false }) tblActiveContracts: T4DatatableWidget;
    @ViewChild("tblUsedStock", { static: false }) tblUsedStock: T4DatatableWidget;

    // View model
    public selectedCustomer: OrderCustomerModel;
    public filteredCustomers: Observable<OrderCustomerModel[]>; 

    public orderTotal: any = {};

    public txtCustomer = new FormControl();

    //Customer info overview
    @ViewChild('customerInfo', {static: false}) overview: CustomerInfo;

    public queryParameters = {};

    public showUsedStock = true;

    public loadingT4StationChange = false;

    public isloaded = false;

    public transferOwnership = false;

  constructor(el: ElementRef, private router: Router, private route: ActivatedRoute, public dialog: MatDialog, private orderSvc: T4TurboOrderService, private orderIntegrationService: OrderService, private authService: AuthService) {

        super(el, "Order");

        this.txtCustomer.valueChanges.subscribe(x => {
          this.filteredCustomers = from(this.Api.get<OrderCustomerModel[]>("/TurboOrder/FilterCustomers", { searchText: x, limit: 50, servicePartner: false }));
        });

    }

    async ngOnInit() {
        this.route.params.subscribe(async params => {
            if (params.Id) {
                var x = await this.Api.get<OrderCustomerModel>("/TurboOrder/GetCustomerByCustomerNo", { customerNo: params.Id });
                if (x)
                    this.selectCustomer(x);
            } else {
                
            }
        });
    }

    public reloadUsedStock() {
        this.showUsedStock = false;
        setTimeout(() => {
            this.showUsedStock = true;
        }, 100);
    }

    public anyChecked(): boolean {
        return this.tblActiveContracts && this.tblActiveContracts.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        }).length > 0;
  }

    /// Actions
    public async createTermination() {

      var orderAfterSixMonths: boolean = false;
      var OffRentActionExists: boolean = false;
        
      if (this.transferOwnership) {
        var rows = this.tblActiveContracts.data.renderedData.filter(function (n, i) {
          var sixMonths = moment().add(6, 'months').startOf('day');
          if (n.TerminationDate > sixMonths) {
            orderAfterSixMonths = true;
          } else if (n.TerminationId) {
            OffRentActionExists = true;
          }
        });
      } else {
        var rows = this.tblActiveContracts.data.renderedData.filter(function (n, i) {
          var sixMonths = moment().add(6, 'months').startOf('day');
          if (n.Terminate && n.TerminationDate > sixMonths) {
            orderAfterSixMonths = true;
          }
        });
      }

        var x: boolean = false;

        if (orderAfterSixMonths) {
            x = await this.UI.confirm("TO.ActiveContracts.headConfirmTermination", "Confirm termination", "TO.ActiveContracts.msgTerminationSixMonths", "One or more contracts have an end date more than 6 months in the future. Do you want to continue?");
        }
        else {
            x = true;
        }

      if (x) {

        var res: boolean = false;

        if (OffRentActionExists) {
          res = await this.UI.confirm("TO.ActiveContracts.headConfirmExistingTermination", "Confirm Existing termination", "TO.ActiveContracts.msgExistingTermination1", "One or more contracts already have an existing termination and those will not be added to the ownership change. Do you want to continue?");
        } else {
          res = true;
        }
        if (res) {
          var rows = this.transferOwnership ? this.tblActiveContracts.data.renderedData.filter(function (n, i) { if (!n.OffRentActionExists) { return n; } }) : this.tblActiveContracts.data.renderedData.filter(function (n, i) { return n.Terminate; });
          var countryRef = (this.selectedCustomer?.Country || rows.find(x => x.Customer)?.Customer?.Country || '').toString().trim().toLowerCase();
          

          this.Dialog.open(TerminationDialog, {
            data: {
              TerminationRows: rows,
              TransferOwnership: this.transferOwnership,
              countryRef: countryRef,
            }
          }).afterClosed().subscribe(() => {
            this.transferOwnership = false;
            this.tblActiveContracts.update();
          });
        }
      }
        return;
    }

    public showTermination(tId: number, contractId: number) {
        this.Dialog.open(TerminationDialog, {
            data: {
            TerminationId: tId,
            ContractId: contractId
            }
        });

        return;
    }

    public async extend() {
        var rows = this.tblActiveContracts.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        });

        if (rows.length > 0) {
            var defaultRow = rows.sort((a, b) => {
                var d1 = a.OffRentDate;
                var d2 = b.OffRentDate;

                if (d1 < d2) return 1;
                return 0;
            })[0];

            var defaultDate = defaultRow.OffRentDate.clone();


            var selectedDate = await this.UI.selectDate(defaultDate.clone().add('month', 3), defaultDate, defaultDate.clone().add('month', 6));
            if (selectedDate) {
                if(selectedDate.date() > 1) selectedDate = selectedDate.startOf('month').add('month', 1);

                var x = await this.UI.confirm("TO.ActiveContracts.headConfirmExtend", "Confirm extension", "TO.ActiveContracts.msgConfirmExtend", "Do you want to extend {0} contracts to {1}", null, [rows.length, selectedDate.format("YYYY-MM-DD")]);
                if (!x) return;

                for (var i of rows) {
                  await this.Api.get<string>("TurboOrder/ExtendContract", { contractId: i.Id, newEndDate: selectedDate });
                }

                this.tblActiveContracts.update();
            }
        }
  }

  public async cancelExtension(id: number) {
    if (await this.Api.get<boolean>("/TurboOrder/CheckActiveContractExtensions", { contractId: id })) {
      var x = await this.UI.confirm("TO.ActiveContracts.headConfirmCancelExtend", "Confirm cancel extension", "TO.ActiveContracts.msgConfirmCancelExtension", "Do you want to cancel the extension ?", null, null);
      if (!x) return;
      await this.Api.get<boolean>("TurboOrder/CancelExtension", { contractId: id, extensionId: null })
      this.tblActiveContracts.update();
    }
  }

    public selectCustomer(customer: OrderCustomerModel) {
      this.selectedCustomer = customer;
        this.queryParameters = { customerId: this.selectedCustomer.Id };

        //this.tblActiveContracts.update();
    }

    public updateTotals() {
        this.orderTotal = {
            costPerMonth: 0,
            salesPrice: 0
        }

        this.tblActiveContracts.data.renderedData.forEach((x, i) => {
            this.orderTotal.costPerMonth += x.PricePerMonth ? x.PricePerMonth : 0;
        });
    }

    /// Data methods
    openOrder(orderId: number) {
      this.router.navigate(['/TurboOrder/Order', orderId]);
      this.tblActiveContracts.update();
    }

  public openContractDialog(contractId: number, vehicleId: string) {
      if(vehicleId)
        ContractDialog.open(this.Dialog, vehicleId);
      else
        ContractDialog.openContract(this.Dialog, contractId);
  }

  public async openVehicle(id: string) {
      var dlg = this.dialog.open(ContractDialog, {
          maxHeight: "calc(100vh - 20px)",
          maxWidth: "calc(100vw - 20px)",
          width: "750px",
          data: {
              vehicleId: id
          }
      });

      var changes = await dlg.afterClosed().toPromise();
      if (changes) {
          this.reloadUsedStock();
      }
  }

    public displayOrderType(orderType): string {
        var orderTypeString = '';
        if (orderType != null && orderType == 7) {
            orderTypeString = 'DLL';
        }
        else if (orderType != null && orderType == 5) {
            orderTypeString = 'Brenderup';
        }
        return orderTypeString;
  }

  public async createT4Station() {
    var x = await this.UI.confirm(
      "TO.ActiveContracts.headConfirmCreateT4",
      "Activate T4?",
      "TO.ActiveContracts.msgConfirmActivateT4",
      "Are you sure you want to activate T4 for this customer? If a station with the same location id (XAL) is found that will be re-activated, otherwise a new location will be created.");

    if (!x) return;

    var token = this.UI.beginLoading("TO.ActiveContracts.msgUpdatingT4", "Updating T4", null);
    var ret = await this.orderSvc.CreateT4Station(this.selectedCustomer.Id, 0);

    if (ret.IsSuccess) {
      this.selectedCustomer.UseT4 = true;
      this.selectedCustomer.T4StationId = ret.Data;
      this.UI.snackBar("Customer was created successfully!", null, 5000);
    } else {
      this.UI.alert(
        "TO.ActiveContracts.headCreateStationFailed",
        "Station could not be created in T4",
        ret.Message,
        null);
    }
    this.UI.loaderCompleted(token);
  }

  public async updateT4Station() {
    this.orderIntegrationService.SendCustomer2T4(this.selectedCustomer.Id);
  }

  public async bindT4Station() {
    var ret = await this.UI.openDialog<LocationInfo>("T4.Common.FindLocationDialog", { data: { Role: "Pick", IsOneWay: false } });
    if (ret) {
      var x = await this.UI.confirm("TO.ActiveContracts.headConfirmTransferT4", "Transfer ownership?", "TO.ActiveContracts.msgConfirmTransferT4", "Are you sure you want to transfer ownership of {0} to this customer?", null, [ret.Name]);
      if (x) {
        var token = this.UI.beginLoading("TO.ActiveContracts.msgUpdatingT4", "Updating T4", null);
        var ret2 = await this.orderSvc.AssignT4Station(this.selectedCustomer.Id, ret.Id);
        this.UI.loaderCompleted(token);

        this.loadingT4StationChange = false;
        if (ret2) {
          this.selectedCustomer.UseT4 = true;
          this.selectedCustomer.T4StationId = ret.Id;
          this.UI.snackBar("Customer was successfully assigned!", null, 5000);
        } else {
          this.UI.alert(
            "TO.ActiveContracts.headAssignStationFailed",
            "Station could not be assigned in T4",
            ret2.Message,
            null);
        }
      }
    }
  }

  public async deactivateT4() {
    var x = await this.UI.confirm("TO.ActiveContracts.headConfirmDeactivateT4", "Deactivate T4?", "TO.ActiveContracts.msgConfirmDeactivateT4", "Are you sure you want to deactivate T4 for this customer? They will no longer be able to log in but all data will be preserved for statistical purposes.", null, null);
    if (!x) return;
    this.loadingT4StationChange = true;
    var token = this.UI.beginLoading("TO.ActiveContracts.msgUpdatingT4", "Updating T4", null);
    var ret = await this.Api.get<boolean>("TurboOrder/DeactivateT4Station", { customerId: this.selectedCustomer.Id });
    this.UI.loaderCompleted(token);
    this.loadingT4StationChange = false;
    if (ret) {
      this.selectedCustomer.UseT4 = false;
      this.selectedCustomer.T4StationId = null;
      this.UI.snackBar("Customer was successfully deactivted!", null, 5000);
    } else {
      this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
    }
  }

  public async addNoteToStock(vehicle: VehicleInfo) {

        var note = await this.UI.prompt("turbo.core.dialogs.CreateService.promptNoteHeadline", "Create note", "TO.ActiveContracts.promptNoteQuery", "Add your note here.");

        if (note) {

            var noteCreated = await this.Api.get<boolean>("TurboOrder/CreateNote", { vehicleId: vehicle.Id, message: note, oldMessage: vehicle.Comment ? vehicle.Comment : null });

            if (noteCreated) {
                this.reloadUsedStock();
                this.UI.alert("TO.ActiveContracts.headNoteCreated", "Note created!", "TO.ActiveContracts.msgNoteCreated", "The note has been added to this vehicle.");
            }
            else {
                this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
            }
        }

  }

  public async removeFromStock(vehicle: VehicleInfo) {

    var vehicles = [];
    if (vehicle) {
      vehicles.push(await this.orderSvc.GetContract(vehicle.Id));
    } else {
      for (var r of this.tblUsedStock.selectedRows) {
        await vehicles.push(await this.orderSvc.GetContract(r.Id));
      }
    }

    var countryRef = (this.selectedCustomer?.Country || vehicles.find(x => x.Customer)?.Customer?.Country || '').toString().trim().toLowerCase();
    var ret = await this.Dialog.open(TerminationDialog, { data: { TerminationRows: vehicles, Comment: "Created from used stock", Insurance: false, TerminationType: 1, TerminateAt: moment(), countryRef: countryRef, countryRf: countryRef } }).afterClosed().toPromise();

   
  }

  public async GetCustomersFromAnataById() {
    var result = await this.Api.get<OrderCustomerModel>("/TurboOrder/GetCustomersFromAnataById", { customerAccount: this.selectedCustomer.AxCustomerNo });
    if (result) {
      this.selectCustomer(result);
      this.tblActiveContracts.update();
      this.UI.alert("TO.Customers.AnnataCustomerSuccess", "Reload completed", "TO.Customers.msgAnnataCustomerSuccess", "Reload from Annata is completed.")
    }
    else {
      this.UI.alert("TO.Customers.AnataFailed", "Failed!", "TO.Customers.msgAnataFailed", "The customers could not be retrieved.")
    }
  }

  public async impersonate() {
    if (!this.selectedCustomer) return;
    var ret = await this.UI.confirm("Turbo.LocationInfo.promptComfirmImpersonate", "Confirm impersonate location", "Turbo.LocationInfo.promptComfirmImpersonateMsg", "Do you want to impersonate the location - {0}?", null, [this.selectedCustomer.Name]);
    if (ret) {
      this.authService.impersonate(this.selectedCustomer.XalAccountNo + "_Admin").then(x => {
      });
    }
    else return;
  }

  public async TransferOwnership() {
    this.transferOwnership = true;
    this.createTermination();
  }
}
